import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import ReactSVG from 'react-svg';
import _ from 'lodash';
import styled from 'styled-components';
import { translate } from "react-i18next";
import DefaultButton from './../../../../../../../components/DefaultButton';
import GhostButton from './../../../../../../../components/GhostButton';
import SelectInput from './../../../../../../../components/SelectInput';
import CloseIcon from './../../../../../../../icons/closeWhite.svg';
import messageManager from './../../../../../../../utilities/messageManager';
import loading from './../../../../../../../utilities/loading';

const ProjectListRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 5px 0;
    >span {
        width: 180px;
    }
`;

const ManagerWrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%);
    background-color: #ffffff;
    border: 1px solid #e1e1e1;
    box-shadow: 0 1px 3px rgba(0,0,0, 0.3);
    min-width: 180px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    text-align: right;
`;

const OutSide = styled.div`
    background-color: #d1d1d1ab;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 2;
`;

const WindowHeader = styled.div`
    width: calc(100% - 20px);
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
    align-items: center;
    padding: 5px 10px;
    background-color: #f8f8fa;
    border-radius: 5px 5px 0 0;
    >span{
        margin-right: 10px;
        font-size: 14px;
    }
`;

const WindowContent = styled.div`
    padding: 5px 10px 5px 10px;
    display: flex;
    flex-direction: column;
`;

const SelectWrapper = styled.div`
    justify-content: space-between;
`;

const ListWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

class ProjectManager extends React.Component {
    constructor(props) {
        super();

        let otherProjects = [];
        props.projects.forEach(project => {
            const userInProject = project.workspaceUsers.find(userData => {
                return userData.user.userName === props.user.userName;
            })
            if (!userInProject) otherProjects.push(project)
        })
        this.state = {
            selectedProject: otherProjects.length > 0 ? otherProjects[0].id : '',
            visible: false,
            grantDisabled: false,
            revokeDisabled: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.projects, prevProps.projects)) {
            let otherProjects = [];
            this.props.projects.forEach(project => {
                const userInProject = project.workspaceUsers.find(userData => {
                    return userData.user.userName === this.props.user.userName;
                })
                if (!userInProject) otherProjects.push(project)
            })
            this.setState({
                selectedProject: otherProjects.length > 0 ? otherProjects[0].id : '',
                grantDisabled: otherProjects.length === 0,
                revokeDisabled: false
            })
        }
    }
    
    grantProject(userId, projectId) {
        const { BASE_URL, axiosInstance, t, getProjects } = this.props;
        const data = {
            userId: userId,
            workspaceId: projectId,
        };
        loading.start();

        axiosInstance.post(`${BASE_URL}account/grant-workspace`, data)
            .then(response => {
                getProjects();
                messageManager.show({
                    type: 'info',
                    text: t('Workspace access granted'),
                });                
                loading.stop();
            })
            .catch(error => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while granting workspace')),
                });
                loading.stop();
            });
    }

    revokeProject(userId, projectId) {
        const { BASE_URL, axiosInstance, t, getProjects } = this.props;
        const data = {
            userId: userId,
            workspaceId: projectId,
        };
        loading.start();

        axiosInstance.post(`${BASE_URL}account/revoke-workspace`, data)
            .then(response => {
                getProjects();
                messageManager.show({
                    type: 'info',
                    text: t('Workspace access revoked'),
                });
                loading.stop();
            })
            .catch(error => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while revoking workspace')),
                });
                loading.stop();
            });
    }

    render() {
        const { t, projects, user } = this.props;

        let userProjects = [],
            otherProjects = [];

        projects.forEach(project => {
            const userInProject = project.workspaceUsers.find(userData => {
                return userData.user.userName === user.userName;
            })
            if (userInProject) userProjects.push(project)
            else otherProjects.push(project)
        })
        if (!this.state.visible) {
            return (
                <DefaultButton
                    onClick={() => {
                        this.setState({ visible: true });
                    }}>
                    {t('Open')}
                </DefaultButton>
            )
        }
        else {
            return (
                <div>
                    <DefaultButton 
                        title={t('Open')}
                        disabled={true}>
                        {t('Open')}
                    </DefaultButton>
                    <OutSide
                        onClick={() => {
                            this.setState({ visible: false });
                        }}>
                        <ManagerWrapper
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                            <WindowHeader>
                                <span>
                                    {t('Grant or revoke access')}
                                </span>
                                <GhostButton
                                    style={{ width: '15px', height: '15px', padding: '0' }}
                                    title={t('Close')}
                                    onClick={() => {
                                        this.setState({ visible: false });
                                    }}>
                                    <ReactSVG
                                        path={CloseIcon}
                                        style={{
                                            fill: '#265a9c',
                                            width: '15px',
                                            height: '15px',
                                            alignItems: 'center',
                                        }}
                                    />
                                </GhostButton>
                            </WindowHeader>
                            <WindowContent>
                                {otherProjects.length > 0
                                    ? <SelectWrapper>
                                        <SelectInput
                                            defaulValue={this.state.selectedProject}
                                            onChange={(e) => { this.setState({ selectedProject: e.target.value }) }}
                                        >
                                            {otherProjects.map(project => {
                                                return (
                                                    <option
                                                        key={`${project.id}_project_manager_option`}
                                                        value={project.id}
                                                    >
                                                        {project.name}
                                                    </option>
                                                )
                                            })}
                                        </SelectInput>
                                        <DefaultButton
                                            style={{ height: '27px', width: '65px' }}
                                            onClick={(e) => {
                                                this.setState({ grantDisabled: true })
                                                this.grantProject(
                                                    user.id,
                                                    this.state.selectedProject,
                                                );
                                            }}
                                            disabled={this.state.grantDisabled}
                                            title={t('Grant workspace')}
                                        >
                                            {t('Grant')}
                                        </DefaultButton>
                                    </SelectWrapper>
                                    : null}
                                <ListWrapper>
                                    {userProjects.map(project => {
                                        return (
                                            <ProjectListRow key={`${project.name}_list_row`}>
                                                <span>
                                                    {project.name}
                                                </span>
                                                <DefaultButton
                                                    type='warning'
                                                    style={{ width: '65px' }}
                                                    disabled={this.state.revokeDisabled}
                                                    onClick={() => {
                                                        this.revokeProject(
                                                            user.id,
                                                            project.id,
                                                        );
                                                        this.setState({ revokeDisabled: true })
                                                    }}
                                                    title={t('Revoke workspace')}
                                                >
                                                    {t('Revoke')}
                                                </DefaultButton>
                                            </ProjectListRow>
                                        )
                                    })}
                                </ListWrapper>
                            </WindowContent>
                        </ManagerWrapper>
                    </OutSide>
                </div>
            )
        }
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ProjectManager));


// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAdmin/userList/projectManager/ProjectManager.jsx